import { createFileRoute, redirect } from "@tanstack/react-router";
import z from "zod";

import { hasInviteControlCharacter } from "@/integrations/multiresume/access/invite-input";

import { RegisterRouteComponent } from "./-register-component";

export const Route = createFileRoute("/auth/register")({
  component: RegisterRouteComponent,
  validateSearch: z.object({
    invite: z
      .string()
      .trim()
      .min(1)
      .max(64)
      .refine((value) => !hasInviteControlCharacter(value), "Invitation code contains unsupported characters.")
      .optional(),
  }),
  head: () => ({ meta: [{ name: "referrer", content: "no-referrer" }] }),
  beforeLoad: async ({ context }) => {
    if (context.session) throw redirect({ to: "/dashboard", replace: true });
    if (context.flags.disableSignups) throw redirect({ to: "/auth/login", replace: true });
    return { session: null };
  },
});
